import React, { createContext, useContext, useState } from "react"
import { appTools, cn } from "lib/utils"

interface IFormProps {
  className?:string
  children:React.ReactNode
  [key:string]:any
}


export default function Form({ className, children, ...rest }:IFormProps){

  return (
    <form className={cn("", className)} {...rest}>
      {children}
    </form>
  )
}